import 'react-loading-skeleton/dist/skeleton.css'
import { StyleSheet, View } from '../../compiler'
import { colors, typoStyles } from '../../constants'
import CoordinateSystem from '../graphs/CoordinateSystem'
import ArrowRightIcon from '../heroicons/micro/ArrowRightIcon'
import MarkdownText from '../MarkdownText'
import RowListItem from '../RowListItem'

import Skeleton from 'react-loading-skeleton'

const styles = StyleSheet.create({
  headerContainer: {
    height: 72,
    paddingHorizontal: 24,
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
    borderWidth: 1,
    borderColor: colors.lightGrey,
    alignItems: 'center'
  },
  coordinateContainer: {
    paddingVertical: 30,
    justifyContent: 'center',
    alignItems: 'center',
    borderLeftWidth: 1,
    borderRightWidth: 1,
    borderColor: colors.lightGrey
  },
  footerContainer: {
    backgroundColor: colors.lightPaleGrey,
    borderWidth: 1,
    borderColor: colors.lightGrey,
    borderBottomLeftRadius: 8,
    borderBottomRightRadius: 8
  }
})

const CultureFitContainer = ({
  containerStyle,
  title,
  userCultureScores,
  insights = [],
  isLoading
}) => {
  return (
    <View style={containerStyle}>
      <View style={styles.headerContainer}>
        <MarkdownText
          style={[typoStyles.H4Black, { textTransform: 'uppercase' }]}
        >
          {isLoading ? <Skeleton width={200} /> : title}
        </MarkdownText>
      </View>
      <View style={styles.coordinateContainer}>
        {isLoading ? (
          <Skeleton height={300} width={300} />
        ) : (
          <CoordinateSystem userCultureScores={userCultureScores} />
        )}
      </View>
      <View style={styles.footerContainer}>
        <View
          style={{
            padding: 24,
            display: 'flex',
            flexDirection: 'column',
            rowGap: 16
          }}
        >
          {isLoading ? (
            <Skeleton count={4} height={24} />
          ) : (
            insights.map((fact, index) => (
              <RowListItem key={index} Icon={ArrowRightIcon} text={fact} />
            ))
          )}
        </View>
      </View>
    </View>
  )
}

export default CultureFitContainer
